import r from "react";
import { UploadErrors as e } from "../UploadErrors/index.js";
function t(t) {
  var o;
  return Object.keys(o = t.errors).reduce(function (r, e) {
    return r + o[e].length;
  }, 0) > 0 ? r.createElement("div", {
    className: "upload-error-summary"
  }, r.createElement(e, {
    type: "size",
    errors: t.errors.size
  }), r.createElement(e, {
    type: "type",
    errors: t.errors.kind
  }), r.createElement(e, {
    type: "other",
    errors: t.errors.other
  })) : null;
}
t.displayName = "FileUploader.ErrorSummary";
export { t as ErrorSummary };